import React, { memo } from 'react';

export const Drop: React.FC = memo(() => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <rect width="32" height="32" fill="white" />
    <path
      d="M16.81 23.1206C17.7878 22.9548 18.69 22.4897 19.3921 21.7893C20.0943 21.089 20.5618 20.1879 20.73 19.2106M24 18.4006C24 11.2006 16 5.60059 16 5.60059C16 5.60059 8 11.2006 8 18.4006C8 20.5223 8.84285 22.5571 10.3431 24.0574C11.8434 25.5577 13.8783 26.4006 16 26.4006C18.1217 26.4006 20.1566 25.5577 21.6569 24.0574C23.1571 22.5571 24 20.5223 24 18.4006Z"
      stroke="#21282B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
